export function GrowthPage() {
  return <div className="text-gray-500">Aggregators, pockets &amp; referrals - coming soon.</div>
}
